export default {
	"forepartner": {
		"addPartner": "添加伙伴",
		"forepartner": "添加成功"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/forepartner/forepartner.js